<script>
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Popin from "@/components/molecules/popin";

export default {
  name: "SuccessPopin",
  components: {
    Badge,
    Icon,
    Popin
  }
};
</script>

<template>
  <Popin
    ref="popin"
    :visible="true"
    aria-label="Demande prise en compte"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <div class="u-text-center u-pb-sm">
      <Badge
        :variant="'success'"
        circle
        size="xlg"
      >
        <Icon
          name="check"
          variant="white"
        />
      </Badge>
      <p class="u-mt-sm u-font-15 u-font-16@sm">
        Votre demande a bien été prise en compte, un retour vous sera apporté dans les meilleurs délais.
      </p>
    </div>
  </Popin>
</template>
